import React from 'react';
// import { Link } from 'react-router-dom';

const RecordsMenu = () => {
	return <></>;
};

export default RecordsMenu;
